module.exports = __webpack_public_path__ + "static/media/bluebird.07680333.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/bluebird.webp
// module id = 375
// module chunks = 0